import { Button, Checkbox, Form, Toast } from 'antd-mobile-v5'
import { FormattedMessage, useIntl } from 'react-intl'
import { Link, useHistory } from 'react-router-dom'
import React, { useState } from 'react'
import { WingBlank } from 'antd-mobile'

import { getCookie } from '../../components/common/cookie'
import { useSaveProfile } from '../../services/hooks/user'
import { UserInfo } from '../IssueCerts/AddStudents'
import EmailVerify from './EmailVerify'
import MobileVerify from './MobileVerify'
import PasswordConfirm from './PasswordConfirm'
import SelectLanguage from '../../components/Login/SelectLanguage'
import { useShowMessage } from '../../services/hooks/ui'
import { useCheckRegisterAgreement, useGetM2PhoneNumber, useMainlandIp } from '../../services/hooks'
import { getParameterByName } from '../../components/common/utils'
import { isTaiwanUser } from '../../utils/user'

import '../emailLogin/emailLogin.css'
import { debug } from '../../utils/env'

import styles from './Register.module.css'

function defaultCountryCode() {
  return getCookie('language') === 'sc' ? '86' : '886'
}

export default function RegisterPage() {
  const { formatMessage } = useIntl()
  const { replace } = useHistory()
  const showMessage = useShowMessage()
  const [form] = Form.useForm()
  const lang = getCookie('language') || 'sc'
  const [emailVerified, setEmailVerified] = useState(false)
  const [mobileVerified, setMobileVerified] = useState(false)
  const [showUserInfoForm, setShowUserInfoForm] = useState(false)
  const [showPasswordForm, setShowPasswordForm] = useState(false)
  const [agreement1, setAgreement1] = useState(false)
  const [agreement2, setAgreement2] = useState(false)
  const [countryCode, setCountryCode] = useState('86')
  const referer = getParameterByName('referer') || ''
  const [showMobileVerify, setMobileVerifyStatus] = useState(false)

  const { loading: profileSaving, run: saveProfile } = useSaveProfile({
    onSuccess: (profile) => {
      if (referer) replace(`/registrationSuccess?referer=${referer}`, { profile })
      else replace('/registrationSuccess', { profile })
    },
    onError: () => {
      replace('/registrationFailure')
    },
  })

  const { data: agreements } = useCheckRegisterAgreement()
  const { data: isMainlandIp } = useMainlandIp({})
  const { run: getM2PhoneNumber, data } = useGetM2PhoneNumber({
    onSuccess: (data) => {
      if (data) {
        if (data.phoneNumber) {
          setCountryCode(data.countryCode || '86')
          form.setFieldsValue({ mobile: data.phoneNumber })
        }
        setMobileVerifyStatus(true)
      }
    },
  })

  const onMobileVerified = ({ verified }) => {
    setMobileVerified(verified)
  }

  const verifyAgreements = () => {
    if (isMainlandIp) {
      return agreement1 && agreement2
    } else {
      return !!agreement1
    }
  }

  const onFinish = (data) => {
    debug('Register info: ', data)
    if (!verifyAgreements()) {
      Toast.show({
        content: '请先阅读并勾选协议。',
      })
      return
    }
    if (!emailVerified) {
      showMessage('register-email-not-verified')
      return
    }
    if (isMainlandIp && countryCode === '86' && !mobileVerified) {
      showMessage('register-mobile-not-verified')
      return
    }
    if ((showUserInfoForm || showPasswordForm) && data.password !== data.passwordConfirm) {
      form.setFields([
        {
          name: 'passwordConfirm',
          errors: [formatMessage({ id: 'setPassword-errorConfirmPassword' })],
        },
      ])
      return
    }

    let saveData = { countryCode }
    if (showPasswordForm) saveData.password = form.getFieldValue('password')
    if (showUserInfoForm) {
      const { agreement, emailCode, password, passwordConfirm, mobileCode, ...otherData } = data
      saveData = {
        ...otherData,
        ...saveData,
        addressCity: form.getFieldValue('addressCity'),
      }
    } else {
      const { agreement, emailCode, mobileCode, ...otherData } = data
      saveData = {
        ...otherData,
        ...saveData,
      }
    }
    if (verifyAgreements()) {
      const userAgreementDTOS = agreements.map((item) => {
        return {
          ...item,
          agree: true,
        }
      })
      saveData = {
        ...saveData,
        userAgreementDTOS,
      }
    }
    saveProfile(saveData)
  }

  return (
    <div className="home-page">
      <SelectLanguage />
      <div className="logo">
        <img src={require('../../assets/images/common/PADI-logo.png')} alt="logo" />
      </div>
      <Form
        initialValues={{ countryCode: defaultCountryCode() }}
        form={form}
        onFinish={onFinish}
        validateTrigger="submit"
        footer={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Button block type="submit" color="primary" loading={profileSaving}>
              {formatMessage({ id: 'loginComponent-signUpTitle' })}
            </Button>
            <Link style={{ padding: '8px' }} to="/emailLogin">
              <FormattedMessage id="common-back" />
            </Link>
          </div>
        }
      >
        <Form.Header>
          <FormattedMessage id="setEmail-title" />
        </Form.Header>

        <EmailVerify
          form={form}
          onVerifyResult={({ verified, needPassword, needUserInfo }) => {
            setEmailVerified(verified)
            setShowUserInfoForm(needUserInfo)
            setShowPasswordForm(needPassword)
          }}
          getM2PhoneNumber={getM2PhoneNumber}
        />
        {showMobileVerify && (
          <>
            <Form.Header>
              <FormattedMessage id="setMobile-title" />
            </Form.Header>
            <MobileVerify
              form={form}
              emailVerified={emailVerified}
              onVerifyResult={onMobileVerified}
              setCountryCode={setCountryCode}
              countryCode={countryCode}
              isMainlandIp={isMainlandIp}
              email={form.getFieldValue('email')}
            />
          </>
        )}
        {showUserInfoForm && (
          <Form.Header>
            <FormattedMessage id="setProfile-title" />
          </Form.Header>
        )}
        {showUserInfoForm && <UserInfo form={form} />}
        {(showUserInfoForm || showPasswordForm) && (
          <Form.Header>
            <FormattedMessage id="setPassword-title" />
          </Form.Header>
        )}
        {(showUserInfoForm || showPasswordForm) && <PasswordConfirm form={form} />}
      </Form>
      <WingBlank>
        <Checkbox className={styles.agreement} checked={agreement1} onChange={(val) => setAgreement1(val)}>
          {isMainlandIp ? (
            <FormattedMessage
              id="common-agreement-hint-mainland"
              values={{
                link1: (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://assets.padi.com.cn/agreements/club-user-agreement.html"
                  >
                    <FormattedMessage id="common-club-agreement" />
                  </a>
                ),
                link2: (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={
                      isTaiwanUser()
                        ? 'https://www.padi.com.tw/zh-hant/privacy'
                        : `https://assets.padi.com.cn/agreement_${lang}.html`
                    }
                  >
                    <FormattedMessage id="common-agreement" />
                  </a>
                ),
              }}
            />
          ) : (
            <FormattedMessage
              id="common-agreement-hint"
              values={{
                link: (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={
                      isTaiwanUser()
                        ? 'https://www.padi.com.tw/zh-hant/privacy'
                        : `https://assets.padi.com.cn/agreement_${lang}.html`
                    }
                  >
                    <FormattedMessage id="common-agreement" />
                  </a>
                ),
              }}
            />
          )}
        </Checkbox>
        {isMainlandIp && (
          <Checkbox className={styles.agreement} checked={agreement2} onChange={(val) => setAgreement2(val)}>
            <FormattedMessage
              id="common-info-agreement-hint"
              values={{
                link: (
                  <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={`https://assets.padi.com.cn/personalInfo_agreement_${lang}.html`}
                  >
                    <FormattedMessage id="common-info-agreement" />
                  </a>
                ),
              }}
            />
          </Checkbox>
        )}
      </WingBlank>
    </div>
  )
}
